/* global axios */
import ApiClient from './ApiClient';

class ConversationAssignmentsAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getAssignments(conversationId) {
    return axios.get(`${this.url}/${conversationId}/assignments`);
  }
}

export default new ConversationAssignmentsAPI();
